// @ngInject
const config = ($stateProvider) => {
  $stateProvider.state('configuration.currencies', {
    url: '/currencies',
    templateUrl: 'main/configuration/currencies/currencies.tpl.html',
    data: { pageTitle: 'Currencies' },
  });
};

angular.module('configuration.currencies', []).config(config);
